import { render, staticRenderFns } from "./Tax.vue?vue&type=template&id=6adfc956"
import script from "./Tax.vue?vue&type=script&lang=js"
export * from "./Tax.vue?vue&type=script&lang=js"
import style0 from "./Tax.vue?vue&type=style&index=0&id=6adfc956&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports